module.exports = __webpack_public_path__ + "img/foot_code_2.2dacd956.png";